import React from "react";
import { FiAlertTriangle, FiX } from "react-icons/fi";

const ConfirmActionModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  subMessage,
  confirmText = "Confirm",
  confirmColor = "blue", // "blue", "red", "emerald"
  loading = false,
  icon: CustomIcon,
}) => {
  if (!isOpen) return null;

  const colorStyles = {
    blue: "bg-blue-600 hover:bg-blue-700 text-white shadow-blue-600/20",
    red: "bg-red-600 hover:bg-red-700 text-white shadow-red-600/20",
    emerald: "bg-emerald-600 hover:bg-emerald-700 text-white shadow-emerald-600/20",
  };

  const iconBgStyles = {
    blue: "bg-blue-50 text-blue-600",
    red: "bg-red-50 text-red-600",
    emerald: "bg-emerald-50 text-emerald-600",
  };

  const IconComponent = CustomIcon || FiAlertTriangle;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 animate-fadeIn"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-md rounded-2xl shadow-xl overflow-hidden flex flex-col transition-all"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
          <div className="flex items-center gap-3">
            <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${iconBgStyles[confirmColor] || iconBgStyles.blue}`}>
              <IconComponent size={18} />
            </div>
            <h2 className="text-sm font-semibold text-gray-800">{title}</h2>
          </div>
          <button
            onClick={onClose}
            disabled={loading}
            className="p-1.5 rounded-lg text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition"
          >
            <FiX size={17} />
          </button>
        </div>

        <div className="p-6">
          <p className="text-sm text-gray-700 leading-relaxed">{message}</p>
          {subMessage && (
            <p className="text-xs text-gray-500 mt-2 bg-gray-50 p-3 rounded-lg border border-gray-100 leading-relaxed">
              {subMessage}
            </p>
          )}
        </div>

        <div className="px-6 py-4 border-t border-gray-100 flex justify-end gap-3 bg-gray-50/50">
          <button
            type="button"
            disabled={loading}
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 rounded-lg transition"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={loading}
            onClick={onConfirm}
            className={`px-4 py-2 text-sm font-medium rounded-lg shadow-sm transition flex items-center gap-2 ${
              colorStyles[confirmColor] || colorStyles.blue
            } ${loading ? "opacity-70 cursor-not-allowed" : ""}`}
          >
            {loading && (
              <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                />
              </svg>
            )}
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmActionModal;
